import React from 'react';
import ReactMarkdown from 'react-markdown';

const Hours = ({text}) => (
    <div>
        <div className="open-hours">
        <ReactMarkdown source={text} softBreak="br" />
        </div>
    </div>
)

export default Hours;


// WEBPACK FOOTER //
// ./src/components/Hours.js